export const asStick = {
  data: `<svg width="2" height="16" viewBox="0 0 2 16"  xmlns="http://www.w3.org/2000/svg">
  <rect x="2" width="16" height="2" rx="1" transform="rotate(90 2 0)" />
  </svg>`,
  name: 'stick',
};
